export const simulateMouseClick = async (element: Element) => {
  const options = { view: window, bubbles: true, cancelable: true, buttons: 1 };
  element.dispatchEvent(new MouseEvent("mousedown", options));
  await new Promise(x => setTimeout(x, 50));
  element.dispatchEvent(new MouseEvent("mouseup", options));
  element.dispatchEvent(new MouseEvent("click", options));
}
